import { Typography, TypographyProps } from '@mui/material';
import { LoremIpsum } from 'lorem-ipsum';

const lorem = new LoremIpsum({
  sentencesPerParagraph: {
    max: 4,
    min: 2,
  },
  wordsPerSentence: {
    max: 8,
    min: 4,
  },
});

export interface FakeParagraphsProps extends Omit<TypographyProps, 'variantMapping'> {
  paragraphs: number;
}

export function FakeParagraphs({ paragraphs, ...props }: FakeParagraphsProps) {
  return (
    <Typography {...props} variantMapping={{ body1: 'div', body2: 'div', inherit: 'div' }}>
      {lorem
        .generateParagraphs(paragraphs)
        .split('\n')
        .map((paragraph, idx) => (
          <p key={`p-${idx}`}>{paragraph}</p>
        ))}
    </Typography>
  );
}
